var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FpvReportsTable',{attrs:{"fpv-reports":_vm.approvedFpvReports,"is-preview":false,"refresh-function":_vm.refreshTable,"loading":_vm.loading}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cf00096","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roboInvesting/ApprovedFpvReportsTab.vue
// module id = null
// module chunks = 